module.exports = __webpack_public_path__ + "img/27000.514950f5.jpg";